module.exports = __webpack_public_path__ + "img/recycle-bin.2ff6ea3a.svg";